module.exports = "<div class=\"toggle\">\n    <input class=\"toggle-input\" type=\"checkbox\" />\n    <button id=\"btn-toggle-{{name}}\" type=\"button\" class=\"toggle-btn {{className}}\" [ngClass]=\"{'toggle-btn-on': on , 'toggle-btn-off': !on }\" [attr.aria-expanded]=\"on\" [disabled]=\"disabledSwitch\" (click)=\"onClick()\"></button>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/toggle-button/toggle-button.component.html
// module id = 1092
// module chunks = 22